import ModalComponent from "..";
import { SinglePayout } from "../../../redux/features/payment/payment.types";
import { formatDate, formatToNaira } from "../../../utils/helpers";
import { ModalCompProps } from "../../../utils/types";
import { Icon } from "../../icon/icon";
import { TableComponent } from "../../table";

export const ViewPayoutModal = ({
  open,
  handleClose,
  payout,
}: ModalCompProps & { payout: SinglePayout }) => {
  return (
    <ModalComponent
      open={open}
      handleClose={handleClose}
      containerClassName="md:!py-[20px] md:!px-[20px] md:!justify-end"
      className="!max-h-[90%] !rounded-t-[16px] !bg-white !p-[20px] md:!max-h-[100%] md:!max-w-[500px] md:!rounded-[16px]"
      dialogClassName="!my-0"
      showHeader
      mobileAnchorBottom
      closeOnOverlayClick
      fullScreen
      showCloseIcon
      showMobileTopBar={false}
    >
      <div className="flex w-full flex-col items-center justify-center gap-[2px] text-center">
        <p className="text-2xl font-bold text-grey-900">
          {formatToNaira(payout.amount)}
        </p>
        <p className="text-grey-500">
          Paid on {formatDate(payout.date, "DD MMM, YYYY • hh:mm A")}
        </p>
      </div>

      <TableComponent
        headers={[]}
        rows={[
          {
            id: 1,
            items: [
              <div className="flex flex-row items-center justify-between gap-2">
                <div className="flex flex-1 flex-col gap-[2px]">
                  <p className="font-bold text-primary">
                    {payout?.payoutAccount?.accountName}
                  </p>
                  <p className="text-grey-500">
                    {payout?.payoutAccount?.accountNumber} ∙{" "}
                    {payout?.payoutAccount?.bankName}
                  </p>
                </div>

                <Icon
                  svg="bank"
                  width={20}
                  height={20}
                  className="text-grey-400"
                />
              </div>,
            ],
          },
          {
            id: 2,
            items: [
              <div className="flex flex-1 flex-col gap-[2px]">
                <p className="text-grey-500">Ticktets Sold</p>
                <p className="font-bold text-primary">
                  {payout.ticketCount}{" "}
                  {payout.ticketCount === 1 ? "Ticket" : "Tickets"}
                </p>
              </div>,
            ],
          },
        ]}
        onRowClick={() => {}}
        isRowClickable={false}
        isTableEmpty={false}
        className="mt-10"
      />
    </ModalComponent>
  );
};
